import { useQuery } from '@tanstack/react-query';
import { getSupportRequestTypes } from '@uplift/api';


export const useSupportRequestTypesQuery = () => {
  return useQuery({
    queryKey: [ 'support', 'types' ],
    queryFn: getSupportRequestTypes,
    select: response => response.data,
  });
};
